module.exports = __webpack_public_path__ + "img/ticket-types.b87b199f.svg";